import englishMessages from 'ra-language-english'

export const i18nEnglish = {
  ...englishMessages,
  verzoekenoverzicht: {
    title: 'Request overview',
    menuLabel: 'Requests',
    settingsDescription: 'View DSO requests belonging to your competent authority.',
    openOverview: 'Go to request overview',
    startDatum: 'Start date',
    eindDatum: 'End date',
    search: 'Search',
    noResults: 'No requests found for the selected period',
    backToList: 'Back to overview',
    detail: {
      general: 'General',
      plichtType: 'Obligation type',
      activiteiten: 'Activities',
      locatie: 'Location',
      notFound: 'Request not found. This type of request may not have details available.',
    },
    columns: {
      verzoeknummer: 'Request number',
      volgnummer: 'Sequence number',
      verzoekNaam: 'Name',
      doelVerzoek: 'Purpose',
      verzoekType: 'Type',
      datumIngediend: 'Date submitted',
      bevoegdGezag: 'Competent authority',
      behandeldienst: 'Processing service',
    },
  },
}
